import { Component, OnInit } from '@angular/core';
import * as servers from '../../services/api/servers';
import {urls} from '../../services/api/urls';
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";
import {BaseComponent} from "../BaseComponent";

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.scss']
})
export class ReportingComponent extends BaseComponent implements OnInit{

  constructor(private http: HttpClient, router: Router, route: ActivatedRoute) {
    super(route, router);
  }

  ngOnInit() {
  }

  returnReporting(url: string, pathRelative: string) {
    if (url.includes('/reporting' + pathRelative)) {
      this.router.navigate(['/reporting']);
    } else {
      this.router.navigate(['/reporting' + pathRelative], { queryParams: { reportSection: true }});
    }
  }

  returnZero() {
    return 0;
  }

}
